import { defineStore } from "pinia";

export const useMarketingStore = defineStore("marketingStore", () => {
  const selectedPrompt = ref(null);

  return {
    selectedPrompt,
  };
});
